import React from "react";
import { useUserContext } from "context/UserContext";
import MarketDataAnalysisBK from "layouts/BK/marketDataAnalysis";
import { normalizeRoleLevel } from "utils/roleUtils";

function MarketDataAnalysis() {
  const { roleLevel } = useUserContext() || {};
  const numericRoleLevel = normalizeRoleLevel(roleLevel);
  if (numericRoleLevel === 1 || numericRoleLevel === 2 || numericRoleLevel === 3) {
    return <MarketDataAnalysisBK />;
  }
  return null;
}

export default MarketDataAnalysis;
